import React, { useCallback, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import classnames from 'classnames';
import { toastr } from 'react-redux-toastr';
import { useTranslation } from 'react-i18next';

import { restorePassword } from '../../../../action/AccountActions';
import CustomButton from '../../../CustomButton';

const RestorePasswordForm = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation('translation', { keyPrefix: 'loginForms.restorePasswordForm' });

    const [data, setData] = useState({
        email: ''
    })
    const [errMessage, setErrMessage] = useState({
        email: ''
    })

    const toggleLoader = useCallback((show) => {
        dispatch({ type: 'TOGGLE_LOADER', payload: show });
    }, [dispatch]);

    const fillForm = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    }

    const checkForm = (data) => {
        let error = false;
        const updatedErrMessage = { ...errMessage };

        for (let i in data) {
            if (data[i] == '') {
                error = true;
                updatedErrMessage[i] = t('errEnterYour') + i + '!';
            }
            else if (updatedErrMessage[i]) {
                updatedErrMessage[i] = null;
            }
        }

        if (!updatedErrMessage['email']) {
            const re = /^([a-zA-Z0-9_\-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(data['email'])) {
                error = true;
                updatedErrMessage['email'] = t('errEmail');
            }
        }

        setErrMessage(updatedErrMessage);
        return error;
    }

    const sendForm = (e) => {
        e.preventDefault();

        const error = checkForm(data);
        if (!error) {
            toggleLoader(true);
            restorePassword(data)
                .then((res, err) => {
                    toggleLoader(false);
                    toastr.success('', t('contentModal'));
                    // ToDo: Cognito - disable
                    // navigate('/reset-password', {
                    //     state: { email: data.email }
                    // });
                })
                .catch((error, p) => {
                    toggleLoader(false);

                    if (error.response.data.response.error && (error.response.data.response.error !== "Specified user does not exist")) {
                        toastr.error(error.response.data.response.error);
                    }
                });
        }
    }

    const onCancelClick = () => {
        navigate('/');
    }

    const { email } = errMessage;

    return (
        <div className="panel-body">
            <h3 className='login-header'>{t('headerPasswordRecovery')}</h3>
            <div className="form-wrapper">

                <form onSubmit={sendForm}>
                    <div className={classnames('login-form form-group', { 'has-error': email })}>
                        <label className={`login-label ${(data.email.length) ? 'active' : ''}`}>{t('labelE-mail')}</label>
                        <input type="text" name="email" className="vehicle-search" onChange={fillForm} placeholder={t('placeholderE-Mail')} />
                        {email && <span className="error-label">{email}</span>}
                    </div>

                    <div className="change-password-submit form-group submit-btn">
                        <CustomButton type="submit" variant="primary" size="lg" id="restore-button">{t('btnSubmit')}</CustomButton>
                        <CustomButton variant="primary-outline" size="lg" onClick={onCancelClick}>{t('btnBack')}</CustomButton>
                    </div>
                </form>

            </div>
        </div>
    )
}

export default RestorePasswordForm;
